import React from 'react';
import { ShieldCheck, Clock, BadgeDollarSign, ThumbsUp } from 'lucide-react';
const REASONS = [{
  title: 'Expert Plumbing Solutions',
  description: 'We use the latest tools and techniques to solve your plumbing issues quickly and effectively, protecting your home.',
  icon: ShieldCheck
}, {
  title: 'Professional Crews',
  description: 'On-time, uniformed, and respectful technicians who treat your property like it was their own.',
  icon: Clock
}, {
  title: 'Upfront Flat-Rate Pricing',
  description: 'No hidden fees or surprise charges. The price we quote is the price you pay, guaranteed.',
  icon: BadgeDollarSign
}, {
  title: 'Satisfaction Guaranteed',
  description: 'We are not finished until you are thrilled with the results. Job done right, every time.',
  icon: ThumbsUp
}];
export function WhyUs() {
  return <section className="py-24 bg-white relative" data-id="element-242">
      <div className="container mx-auto px-4" data-id="element-243">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-244">
          <div className="lg:w-1/2" data-id="element-245">
            <div className="text-left mb-12" data-id="element-246">
              <h2 className="font-display text-4xl md:text-5xl text-slate-900 uppercase tracking-wide mb-4" data-id="element-247">
                Why Choose{' '}
                <span className="text-accent" data-id="element-248">Cockrell Custom Repairs</span>
              </h2>
              <p className="text-slate-600 text-lg" data-id="element-249">
                We are committed to providing top-tier home improvement and
                repair services to our Oklahoma neighbors, ensuring your home is
                safe, clean, and functioning perfectly.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-250">
              {REASONS.map((reason, idx) => <div key={idx} className="flex flex-col items-start text-left relative" data-id="element-251">
                  <div className="h-16 w-16 rounded-full bg-slate-50 border-2 border-accent flex items-center justify-center mb-4 shadow-[0_0_20px_rgba(29,58,99,0.15)]" data-id="element-252">
                    <reason.icon className="h-8 w-8 text-accent" data-id="element-253" />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-254">
                    {reason.title}
                  </h3>
                  <p className="text-slate-600 text-sm" data-id="element-255">{reason.description}</p>
                </div>)}
            </div>
          </div>

          <div className="lg:w-1/2 w-full" data-id="element-256">
            <img src="https://images.unsplash.com/photo-1556909212-d5b604d0c90d?q=80&w=1000&auto=format&fit=crop" alt="Bright residential kitchen with sink and plumbing fixtures" className="rounded-2xl shadow-2xl border-2 border-slate-200 w-full h-auto object-cover max-h-[600px]" data-id="element-257" />
          </div>
        </div>
      </div>
    </section>;
}